import { AnchorHTMLAttributes } from "react"
import { Link } from "react-router-dom"

export function MyAuthorizationLink({
    children,
    ...props
}: AnchorHTMLAttributes<HTMLAnchorElement>) {
    return (
        <Link to="/my/authorization" {...props}>
            {children}
        </Link>
    )
}
